L.Edit ?= {}

class L.Edit.PolyWithHoles extends L.Handler


    initialize: (poly, options) ->
        @_poly = poly
        @_poly.isValid = true
        L.setOptions this, options

        @options.successColor ?= if options?.color? then options.color else '#00ff00'
        @options.errorColor ?= '#ff0000'

        @_handlers = []
        L.Edit.PolyWithHoles.include L.Mixin.Events

    clearMarkers: () ->
        for l in @_handlers
            l?._markerGroup?.eachLayer (l) =>
                App.map.removeLayer(l)

    # Attach handlers to the poly's outer boundary as well
    # as one handler for each hole
    addHooks: () ->
        l = new L.Edit.BetterPoly(@_poly, { latlngs: @_poly._latlngs })
        l.enable?()
        @_handlers.push l


        if @_poly?._holes?
            for v, i in @_poly?._holes
                l = new L.Edit.BetterPoly(@_poly, { latlngs: v })
                l.enable?()
                @_handlers.push l

        @_poly.on 'edit', @_fireEdit

        @_tooltip = new L.Tooltip(@_poly._map)
        # add a tooltip so we can give feedback
        if @_poly?._map?
            L.DomUtil.disableTextSelection()


            @_setTooltipHelp?()


            @_poly?._map.on 'mousemove', @_onMouseMove
            @_poly?._map.fire 'mousemove'



    _setTooltipHelp: () =>
        if not @_tooltip._container?
            return

        @_tooltip.removeError().updateContent
            text: 'Click and drag a point to move it. <br />
                Single click a point to delete it. <br />
                Click and drag a ghost point to add a new point <br />
            '
        @_poly.setStyle { color: @options.successColor }


    _setTooltipError: () =>
        @_tooltip.showAsError().updateContent
            text: 'Areas may not intersect themselves'

        @_poly.setStyle({ color: @options.errorColor })


    _onMouseMove: (e) =>
        @_updateTooltip e.latlng



    _fireEdit: (e) =>
        p = L.GeoUtil.readToJSTS @_poly

        if p.geometry?
            p = p.geometry

        if not p.isValid()
            @_setTooltipError()
            @fire 'geometry-invalid'
            @_poly.isValid = false
        else
            @_setTooltipHelp()
            @fire 'geometry-valid', { layer: @_poly }
            @_poly.isValid = true



    _updateTooltip: (latlng) =>
        if latlng
            @_tooltip.updatePosition(latlng)

    removeHooks: (cb = false) ->

        for i in @_handlers
            i?.disable?()

        @_tooltip?.dispose?()
        @_poly?._map?.off?('mousemove', @_onMouseMove)
        @_poly?.off?('edit')
        @clearAllEventListeners()

        if cb isnt false
            cb()
